import { render, staticRenderFns } from "./reconsiderBasic.vue?vue&type=template&id=9822135c&"
import script from "./reconsiderBasic.vue?vue&type=script&lang=js&"
export * from "./reconsiderBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports